import {
  SUBSCRIPTIONS_SHOW_INFOBOX,
  SUBSCRIPTIONS_HIDE_INFOBOX,
  SUBSCRIPTIONS_SHOW_TROLLEY_INFOBOX,
  SUBSCRIPTIONS_HIDE_TROLLEY_INFOBOX,
  SUBSCRIPTIONS_ADD_SUBSCRIPTIONS_INFO,
  SUBSCRIPTIONS_FETCH_ERROR,
  SUBSCRIPTIONS_SUBSCRIBE,
  SUBSCRIPTIONS_CHANGE_QUANTITY,
  SUBSCRIPTIONS_DELETE,
  SUBSCRIPTIONS_RESET,
  SUBSCRIPTIONS_WAIT_FOR_SUBSCRIPTION_CONFIRMATION,
  SUBSCRIPTIONS_UPDATE_FREQUENCY,
  SUBSCRIPTIONS_CHANGE_FREQUENCY_IN_EDIT_MODE,
  SUBSCRIPTIONS_REMOVE_FREQUENCY_FROM_EDIT_MODE,
} from 'apps/subscriptions/actions/subscriptions';
import {
  SUBSCRIPTIONS_PCOP_RECOMMENDATIONS,
  RECOMMENDATIONS_SHOW_MODAL,
  RECOMMENDATIONS_HIDE_MODAL,
} from 'apps/subscriptions/actions/recommendedSubscriptions';

import { DEFAULT_FREQUENCY } from 'apps/subscriptions/components/fopPartials/SubscriptionsFrequencyOptions';

export const initialState = {
  subscriptionsBySku: {},
  frequenciesBySkuInEditMode: {},
  errorMessage: null,
  defaultFrequency: DEFAULT_FREQUENCY,
  showInfoBox: false,
  showTrolleyInfoBox: true,
  recommendations: null,
  recommendationsModalVisible: false,
};

const ACTIONS = {
  [SUBSCRIPTIONS_HIDE_INFOBOX]: ({ state }) => ({ ...state, showInfoBox: false }),
  [SUBSCRIPTIONS_HIDE_TROLLEY_INFOBOX]: ({ state }) => ({ ...state, showTrolleyInfoBox: false }),
  [SUBSCRIPTIONS_SHOW_TROLLEY_INFOBOX]: ({ state }) => ({ ...state, showTrolleyInfoBox: true }),
  [SUBSCRIPTIONS_SHOW_INFOBOX]: ({ state }) => ({ ...state, showInfoBox: true }),
  [SUBSCRIPTIONS_ADD_SUBSCRIPTIONS_INFO]: ({ state, action }) =>
    ({ ...state, errorMessage: null, subscriptionsBySku: action.subscriptionsBySku }),
  [SUBSCRIPTIONS_FETCH_ERROR]: ({ state, action }) => ({ ...state, errorMessage: action.errorMessage }),
  [SUBSCRIPTIONS_WAIT_FOR_SUBSCRIPTION_CONFIRMATION]: ({ state, action }) => {
    const pendingSubscription = {
      [action.sku]: {
        pending: true,
      },
    };
    return { ...state, subscriptionsBySku: { ...state.subscriptionsBySku, ...pendingSubscription } };
  },
  [SUBSCRIPTIONS_SUBSCRIBE]: ({ state, action }) => {
    const newSubscription = {
      [action.sku]: {
        quantity: 1,
        frequency: action.frequency,
        nextAddDate: action.nextAddDate,
      },
    };

    return { ...state, subscriptionsBySku: { ...state.subscriptionsBySku, ...newSubscription } };
  },
  [SUBSCRIPTIONS_UPDATE_FREQUENCY]: ({ state, action }) => {
    const subscriptionWithNewFrequency = {
      [action.sku]: {
        ...state.subscriptionsBySku[action.sku], frequency: action.frequency, nextAddDate: action.nextAddDate,
      },
    };
    return { ...state, subscriptionsBySku: { ...state.subscriptionsBySku, ...subscriptionWithNewFrequency } };
  },
  [SUBSCRIPTIONS_CHANGE_FREQUENCY_IN_EDIT_MODE]: ({ state, action }) => {
    const newFrequency = {
      [action.sku]: action.frequency,
    };
    return { ...state, frequenciesBySkuInEditMode: { ...state.frequenciesBySkuInEditMode, ...newFrequency } };
  },
  [SUBSCRIPTIONS_REMOVE_FREQUENCY_FROM_EDIT_MODE]: ({ state, action }) => {
    const frequenciesBySkuInEditMode = { ...state.frequenciesBySkuInEditMode };
    delete frequenciesBySkuInEditMode[action.sku];
    return { ...state, frequenciesBySkuInEditMode };
  },
  [SUBSCRIPTIONS_CHANGE_QUANTITY]: ({ state, action }) => {
    const subscriptionWithNewQuantity = {
      [action.sku]: { ...state.subscriptionsBySku[action.sku], quantity: action.quantity },
    };
    return { ...state, subscriptionsBySku: { ...state.subscriptionsBySku, ...subscriptionWithNewQuantity } };
  },
  [SUBSCRIPTIONS_DELETE]: ({ state, action }) => {
    const newSubscriptionsBySku = { ...state.subscriptionsBySku };
    delete newSubscriptionsBySku[action.sku];
    return { ...state, subscriptionsBySku: newSubscriptionsBySku };
  },
  [SUBSCRIPTIONS_RESET]: ({ state }) => ({ ...state, subscriptionsBySku: {} }),
  [SUBSCRIPTIONS_PCOP_RECOMMENDATIONS]: ({ state, action }) => ({ ...state, recommendations: action.recommendations }),
  [RECOMMENDATIONS_SHOW_MODAL]: ({ state }) => ({ ...state, recommendationsModalVisible: true }),
  [RECOMMENDATIONS_HIDE_MODAL]: ({ state }) => ({ ...state, recommendationsModalVisible: false }),
};

export default function subscriptions(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
